import { GraphQLClient } from "../../../../shared/gql-client";
import { gql } from "@apollo/client";
import { LogModel } from "../../domain/models/logModels";

export default class LogService {
  private client: GraphQLClient | undefined;

  setClient(client: GraphQLClient) {
    this.client = client;
  }

  getAllEntityNames(): Promise<string[]> {
    return new Promise((resolve, reject) => {
      const query = gql(`
                query {
                    allEntityNames
                }
            `);

      this.client
        ?.mutate("allEntityNames", query)
        .then((response) => {
          const data = response;
          resolve(data as string[]);
          return data;
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  getEntityLog(entity: string, id: number): Promise<{ data: Array<LogModel> }> {
    return new Promise((resolve, reject) => {
      const query = gql(`
                query {
                    logs(where: { allOf: [
                        {field: {subject_type: {equal: "${entity}"}}},
                        {field: {subject_id: {equal: "${id}"}}},
                    ] }
                        sort: {field: {created_at: Desc}}
                    ) {
                        data {
                            id
                            subject_type
                            subject_id
                            event
                            description
                            properties
                            causer {
                                id
                                name
                                label
                                username
                            }
                            created_at
                        }
                    }
                }
            `);

      this.client
        ?.mutate("logs", query)
        .then((response) => {
          const data = response;
          resolve(data as { data: Array<LogModel> });
          return data;
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
